if (typeof customElements.get('simple-slideshow-banner') == 'undefined') {
	class SimpleSlideshowBanner extends HTMLElement {
		constructor() {
			super();

			this.uniqueClass = `.splide--${this.dataset.id}`;
			this.slider = this.querySelector('.splide');
			this.slides = this.slider.querySelectorAll('.splide__slide');
			this.autoplay = this.slider.dataset.autoplay;
			this.options = this.slider.dataset.options;
			this.arrows = this.slider.dataset.arrows;

			this.init();
		}

		init() {
			this.initSlider();
		}

		initSlider() {
			if (this.slides.length < 2) return;

			const splide = new Splide(this.uniqueClass, {
				type: 'fade',
				perPage: 1,
				drag: true,
				arrows: this.arrows === 'true',
				pagination:
					this.options === 'none'
						? false
						: this.options === 'dots'
						? true
						: {
								type: 'fraction',
								render: function (data) {
									return `${data.index + 1} of ${data.pages}`;
								},
						  },
				fade: true,
				autoplay: this.autoplay === 'true',
				lazyLoad: 'nearby',
				interval: 3000,
				rewind: true,
			});

			if (this.options === 'numbers') {
				splide.on('pagination:mounted', function (data) {
					// You can add your class to the UL element
					data.list.classList.add('splide__pagination--custom');

					// `items` contains all dot items
					data.items.forEach(function (item) {
						item.button.textContent = String(item.page + 1);
					});
				});
			}

			splide.mount();

			this.pagination = this.slider.querySelector('.splide__pagination');

			if (this.options === 'dots') {
				this.pagination.classList.add('splide__pagination--dots');
			}
		}
	}
	customElements.define('simple-slideshow-banner', SimpleSlideshowBanner);
}
